import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import './App.css';
import SubscriptionSearch from './components/SubscriptionSearch';
import HomePage from './components/pages/HomePage';
import RegisterSales from './components/RegisterSales';
import StatisticsPage from './components/StatisticsPage';
import SellerOptions from './components/SellerOptions';
import AccountRegistration from './components/AccountRegistration';
import PlatformAccounts from './components/PlatformAccounts';
import ExpiringSubscriptions from './components/ExpiringSubscriptions';
import AccountSearchPage from './components/AccountSearchPage';
import RegisterSeller from './components/RegisterSeller';
import CodeLogin from './components/CodeLogin'; 
import PlatformMenu from './components/PlatformMenu';
import DisneyPanel from './components/DisneyPanel';
import CodePage from './components/CodePage';
import PrimePanel  from './components/PrimePanel';
import Tutorials from './components/Tutorials'; 
import RegisterUser from './components/RegisterUser'; 
import LoginUser from './components/LoginUser';
import Catalog from './components/pages/Catalog';
import PasswordRecovery from './components/PasswordRecovery';
import PageStore from './components/pages/PageStore';
import ProtectedRoute from './components/ProtectedRoute';
import ProtectedVendorRoute from './components/ProtectedVendorRoute';
import { AuthProvider } from './context/AuthContext'; 
import Store from './components/Store';
import ProtectedUserRoute from './components/ProtectedUserRoute';
import AccountPage from './components/pages/AccountPage';
import Mediospago from './components/pages/mediosPago';
import ActiveAccounts from './components/pages/activeAccounts';
import Renewal from './components/pages/Renewal';
import { SearchProvider } from './context/SearchContext';


function App() {
    return (
        <AuthProvider> 
            <Router>

                
                <Routes>
                    {/* Ruta pública */}

                    <Route
                        path="/register-user"
                        element={
                                <RegisterUser />
                        }
                    />
                    <Route
                        path="/login-user"
                        element={
                                <LoginUser />
                        }
                    />
                    
                    <Route
                        path="/password-recovery"
                        element={
                                <PasswordRecovery />
                        }
                    />

                    <Route
                        path="/seller-options"
                        element={
                                <SellerOptions />
                        }
                    />

                    <Route
                        path="/tutorials"
                        element={
                                <Tutorials />
                        }
                    />

                    <Route
                        path="/code-login"
                        element={
                                <CodeLogin/>
                        }
                    />
           
                    <Route
                        path="/"
                        element={
                                <SearchProvider>
                                <Store/>
                                </SearchProvider>
                        }
                    />
       

                    {/* Rutas protegidas vendedor */}

                    <Route
                    path="/platform-menu"
                    element={
                        <ProtectedVendorRoute>
                        <PlatformMenu />
                        </ProtectedVendorRoute>
                    }
                    />
                    

                    <Route
                    path="/disney-panel"
                    element={
                        <ProtectedVendorRoute>
                        <DisneyPanel/>
                        </ProtectedVendorRoute>
                    }
                    />

                    <Route
                    path="/prime-panel"
                    element={
                        <ProtectedVendorRoute>
                        <PrimePanel/>
                        </ProtectedVendorRoute>
                    }
                    />

                    <Route
                    path="/code-page"
                    element={
                        <ProtectedVendorRoute>
                        <CodePage/>
                        </ProtectedVendorRoute>
                    }
                    />

                {/* Rutas protegidas por Admin*/}
                    <Route
                        path="/home"
                        element={
                            <ProtectedRoute>
                                <HomePage />
                            </ProtectedRoute>
                        }

                        
                    />

                    <Route 
                        path="/subscription-search" 
                        element={
                        <SubscriptionSearch />
                        } 
                        />

                    <Route
                        path="/register-sales"
                        element={
                            <ProtectedRoute>
                                <RegisterSales />
                            </ProtectedRoute>
                        }
                    />

                    <Route
                        path="/catalog"
                        element={
                            <ProtectedRoute>
                                <Catalog />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/statistics"
                        element={
                            <ProtectedRoute>
                                <StatisticsPage />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/register-account"
                        element={
                            <ProtectedRoute>
                                <AccountRegistration />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/platform-accounts"
                        element={
                            <ProtectedRoute>
                                <PlatformAccounts />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/expiring-subscriptions"
                        element={
                            <ProtectedRoute>
                                <ExpiringSubscriptions />
                            </ProtectedRoute>
                        }
                    />

                    <Route
                        path="/register-seller"
                        element={
                            <ProtectedRoute>
                                <RegisterSeller/>
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/account-search"
                        element={
                            <ProtectedRoute>
                                <AccountSearchPage />
                            </ProtectedRoute>
                        }
                    />
                    
                    {/* Rutas protegidas de usuario*/}

                   
                    <Route
                    path="/page-store"
                    element={
                         <SearchProvider>
                        <ProtectedUserRoute>
                        <PageStore />
                        </ProtectedUserRoute>
                        </SearchProvider>
                        
                    }
                    />
                    

                   <Route
                    path="/medios-pago"
                    element={
                        <SearchProvider>
                        <ProtectedUserRoute>
                        <Mediospago />
                        </ProtectedUserRoute>
                        </SearchProvider>
                    }
                    />

                    <Route
                    path="/renewal"
                    element={
                        <SearchProvider>
                        <ProtectedUserRoute>
                        <Renewal />
                        </ProtectedUserRoute>
                        </SearchProvider>
                    }
                    />

                   
                    <Route
                    path="/account"
                    element={
                         <SearchProvider>
                        <ProtectedUserRoute>
                        <AccountPage/>
                        </ProtectedUserRoute>
                        </SearchProvider>
                    }
                    />
                    

                    <Route
                    path="/activate-accounts"
                    element={
                        <SearchProvider>
                        <ProtectedUserRoute>
                        <ActiveAccounts/>
                        </ProtectedUserRoute>
                        </SearchProvider>
                    }
                    />
                    

                </Routes>

            </Router>
        </AuthProvider>
    );
}

export default App;
